import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

import { default as pack } from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  public packageVersion = pack.version;
  public isTest = false;

  constructor(public http: HttpClient) {}

  ngOnInit() {
    this._initDataDogForDevEnv();
  }

  private _initDataDogForDevEnv(): void {
    datadogRum.setGlobalContextProperty('team', 'brazil_digital_paas');
    datadogRum.setGlobalContextProperty('coststring', '1800.br.124.404006');
    datadogRum.setGlobalContextProperty('businessservice', 'authme');

    datadogRum.init({
      applicationId: '677779a3-22fa-459a-be79-c08a090d1ee7',
      clientToken: 'pub00e5b33ed69503599fe7ba794af5f228',
      site: 'datadoghq.com',
      service: 'experian-product-menu-uatpe',
      env: 'uat',
      version: this.packageVersion,
      sessionSampleRate: 10,
      sessionReplaySampleRate: 5,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }
}
